/**
 * Created by YJZX-LCH on 2017-04-11.
 */
import axios from 'axios';
import config from '../../config';
import store from '../store';
import { MessageBox,Toast } from 'mint-ui';
import router from '../router';
//  配置 baseUrl
const baseUrl = process.env.NODE_ENV === 'production' ? config.build.baseUrl : (config.dev.baseUrl + ':' + config.dev.port) + '/';
const instance = axios.create({
  baseURL: baseUrl,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json',
    // 'Content-Type': 'application/json',
  },
  withCredentials: false,
  validateStatus: function (status) {
    return status >= 200 && status <= 299;
  }
});
let isexpiredShown = false;
//请求拦截器，添加herders头
instance.interceptors.request.use(
  config => {
    if (store.state.userInfo.user) {
      config.headers['token'] = store.state.userInfo.user.token
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
//响应拦截器
instance.interceptors.response.use(
  response =>{
    if(response.status==200){
      isexpiredShown = false;
    }
    return response;
  },
  error =>{
    
    // if(error.response.data.msg == "您已在别处登录，请您修改密码或重新登录" || error.response.data.msg == "token已过期"){
      if(error.response.status === 401){
          if(!isexpiredShown){
                  isexpiredShown = true;
                  MessageBox.confirm(error.response.data.msg, '提示', {
                    showCancelButton:false,
                    closeOnClickModal:false,
                    confirmButtonText: '确认',
                    type: 'warning'
                  }).then(() => {
                    // 点击确认按钮后重新登录
                    store.commit('clearUserInfo');
                    store.commit('clearLoginInfo');
                    router.push({path: '/login'});
                  })
          }
        }
    // }else if(error.response.status==200){
    //       isexpiredShown = false;
    // }
    return Promise.reject(error)
  }
)

export default instance;



// WEBPACK FOOTER //
// ./src/api/axios.js